import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

export default function NuestraHistoria() {
  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Nuestra historia' }]} />
      <div style={{ maxWidth:860, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,42px)', color:'var(--forest)', marginBottom:8 }}>Nuestra historia</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:32 }} />
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(280px,1fr))', gap:32, alignItems:'center', marginBottom:60 }}>
          <div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:26, color:'var(--forest)', marginBottom:16 }}>Fundada con proposito</h2>
            <p style={{ fontSize:16, lineHeight:1.8, color:'var(--ink-light)', marginBottom:16 }}>
              Wawita Eco Friendly nacio en 2023 en Pasto, Narino, Colombia, de la mano de Ana Lorena Caicedo, Ingeniera Ambiental con pasion por la sostenibilidad y el cuidado personal.
            </p>
            <p style={{ fontSize:16, lineHeight:1.8, color:'var(--ink-light)', marginBottom:16 }}>
              El nombre "Wawita" viene del quechua y significa "bebe" o "nino pequeno", reflejando nuestro compromiso con productos seguros para toda la familia.
            </p>
            <p style={{ fontSize:16, lineHeight:1.8, color:'var(--ink-light)' }}>
              Wawita nace como respuesta a la creciente demanda de productos cosmeticos que no solo cuiden la piel, sino tambien el medio ambiente.
            </p>
          </div>
          <div style={{ background:'linear-gradient(135deg, #e8f3e6, #f0f7f0)', borderRadius:24, padding:40, textAlign:'center' }}>
            <img src="https://res.cloudinary.com/dcbd2vdzn/image/upload/v1777340903/logo_wawita2_tge5t4.png" alt="Wawita" style={{ width:180, height:180, objectFit:'contain' }} />
            <div style={{ marginTop:20, fontSize:14, color:'var(--sage)', fontWeight:600 }}>Fundada en 2023 · Pasto, Colombia</div>
          </div>
        </div>
        <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:20, padding:40, marginBottom:48 }}>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:26, color:'var(--forest)', marginBottom:24, textAlign:'center' }}>Nuestro proposito</h2>
          <p style={{ fontSize:18, lineHeight:1.8, color:'var(--forest)', textAlign:'center', fontStyle:'italic', maxWidth:600, margin:'0 auto' }}>
            "Cuidar de las personas y del planeta a traves de cosmetica natural, segura y sostenible"
          </p>
        </div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:28, color:'var(--forest)', marginBottom:28 }}>Nuestros diferenciales</h2>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px,1fr))', gap:24 }}>
          {[
            { icon:'🌿', title:'Formulas propias', desc:'Desarrollamos productos con ingredientes 100% naturales, seguros y efectivos.' },
            { icon:'♻️', title:'Envases biodegradables', desc:'Compromiso total con la reduccion de residuos mediante envases biodegradables.' },
            { icon:'🏆', title:'Respaldo institucional', desc:'Contamos con el respaldo de Fundacion Ecociudad.' },
          ].map(d => (
            <div key={d.title} style={{ background:'#fff', borderRadius:16, padding:28, boxShadow:'var(--shadow-xs)', textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:14 }}>{d.icon}</div>
              <h3 style={{ fontFamily:'var(--font-display)', fontSize:18, color:'var(--forest)', marginBottom:10 }}>{d.title}</h3>
              <p style={{ fontSize:13, color:'var(--ink-light)', lineHeight:1.7 }}>{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
